export default __webpack_public_path__ + "static/media/discharging.9972a025.svg";